import * as Sentry from "@sentry/browser";
import GtmEvent from "components/gtm_event";
import FbPixelEvent from "components/fb_pixel_event";

class TrackingEvent {
  constructor(dataLayer, fbq) {
    this.gtmEvent = null
    this.fbEvent = null

    // gtm 會拉取 dataLayer 的資料
    if(dataLayer) {
      this.gtmEvent = new GtmEvent(dataLayer)
    } else {
      console.error('GTM not found');
      Sentry.captureException('GTM not found');
    }

    // fb
    if(fbq) {
      this.fbEvent = new FbPixelEvent(fbq)
    } else {
      console.error('FB not found');
      Sentry.captureException('FB not found');
    }
  }
  // ga4 ecommerce event list

  // normal
  // 1. view_item         - postEventInfo 
  // 2. add_to_cart       - postEventInfo
  // 3. remove_from_cart  - postEventInfo
  // 4. add_to_wishlist   - postEventInfo
  
  // checkout start
  // 5. view_cart         - cartEventInfo
  // 6. begin_checkout    
  // 7. add_shipping_info
  // 8. add_payment_info
  // 9. purchase          - puchaseInfo

  // 10. refund
  // 11. view_item_list
  // 12. select_item

  // FB
  // normal
  // 1. ViewContent         - postEventInfo
  // 2. AddToCart
  // 3. AddToWishlist
  // 4. CompleteRegistration
  // 5. InitiateCheckout
  // 6. Purchase


  // post event
  view_item(postData) {
    try{
      if(postData) {
        if(this.gtmEvent) this.gtmEvent.postEvent('view_item', postData)
        if(this.fbEvent) this.fbEvent.postEvent('ViewContent', postData)

      }
    } catch(err) {
      Sentry.captureException(`view_item error: ${err}`);
    }
  }

  // cart
  add_to_cart(postData) {
    try{
      if(postData) {
        if(this.gtmEvent) this.gtmEvent.postEvent('add_to_cart', postData.post)
        if(this.fbEvent) this.fbEvent.postEvent('AddToCart', postData)

      }
    } catch(err) {
      Sentry.captureException(`add_to_cart error: ${err}`);
    }
  }

  remove_from_cart(postData) {
    try{
      if(postData) {
        if(this.gtmEvent) this.gtmEvent.postEvent('remove_from_cart', postData)
      }
    } catch(err) {
      Sentry.captureException(`remove_from_cart error: ${err}`);
    }
  }

  // cart event
  view_cart(cartData) {
    try{
      if(cartData) {
        if(this.gtmEvent) this.gtmEvent.cartEvent('view_cart', cartData)
      }
    } catch(err) {
      Sentry.captureException(`view_cart error: ${err}`);
    }
  }

  // download
  post_download(downloadData) {
    try{
      if(downloadData) {
        if(this.gtmEvent) this.gtmEvent.trackDownload('post_download', downloadData)
      }
    } catch(err) {
      Sentry.captureException(`post_download error: ${err}`);
    }
  }

  share(shareData) {
    try{
      if(shareData) {
        if(this.gtmEvent) this.gtmEvent.share(shareData)
      }
    } catch(err) {
      Sentry.captureException(`share error: ${err}`);
    }
  }

  // use backend api
  // sign_up(userData) {}

  // purchase
  purchase(orderData) {
    try{
      if(orderData) {
        if(this.gtmEvent) this.gtmEvent.purchase(orderData)
        if(this.fbEvent) this.fbEvent.purchase(orderData)

      }
    } catch(err) {
      Sentry.captureException(`purchase error: ${err}`);
    }
  }

  // tier 1 events

  search(searchData) {
    try{
      if(searchData) {
        if(this.gtmEvent) this.gtmEvent.search(searchData)
      }
    } catch(err) {
      Sentry.captureException(`search error: ${err}`);
    }
  }

  view_item_list(listData) {
    try{
      if(listData) {
        if(this.gtmEvent) this.gtmEvent.viewItemList(listData)
      }
    } catch(err) {
      Sentry.captureException(`view_item_list error: ${err}`);
    }
  }

  select_item(selectData) {
    try{
      if(selectData) {
        if(this.gtmEvent) this.gtmEvent.selectItem(selectData)
      }
    } catch(err) {
      Sentry.captureException(`select_item error: ${err}`);
    }
  }

  add_to_wishlist(postData) {
    try{
      if(postData) {
        if(this.gtmEvent) this.gtmEvent.postEvent('add_to_wishlist', postData)
      }
    } catch(err) {
      Sentry.captureException(`add_to_wishlist error: ${err}`);
    }
  }

  apply_coupon(couponData) {
    try{
      if(couponData) {
        if(this.gtmEvent) this.gtmEvent.applyCoupon(couponData)
      }
    } catch(err) {
      Sentry.captureException(`apply_coupon error: ${err}`);
    }
  }

  // tier 2 events

  like_post(data) {
    try{
      if(data) {
        if(this.gtmEvent) this.gtmEvent.likePost(data)
      }
    } catch(err) {
      Sentry.captureException(`like_post error: ${err}`);
    }
  }

  follow_creator(data) {
    try{
      if(data) {
        if(this.gtmEvent) this.gtmEvent.followCreator(data)
      }
    } catch(err) {
      Sentry.captureException(`follow_creator error: ${err}`);
    }
  }

  click_banner(data) {
    try{
      if(data) {
        if(this.gtmEvent) this.gtmEvent.clickBanner(data)
      }
    } catch(err) {
      Sentry.captureException(`click_banner error: ${err}`);
    }
  }

  view_serie(data) {
    try{
      if(data) {
        if(this.gtmEvent) this.gtmEvent.viewSerie(data)
      }
    } catch(err) {
      Sentry.captureException(`view_serie error: ${err}`);
    }
  }

  // unified module impression/click events
  // 供任何頁面區塊（推薦模組、banner、Weekly Drop、feed 卡片...）統一回報曝光/點擊

  track_module_impression(data) {
    try{
      if(data) {
        if(this.gtmEvent) this.gtmEvent.moduleImpression(data)
      }
    } catch(err) {
      Sentry.captureException(`track_module_impression error: ${err}`);
    }
  }

  track_module_click(data) {
    try{
      if(data) {
        if(this.gtmEvent) this.gtmEvent.moduleClick(data)
      }
    } catch(err) {
      Sentry.captureException(`track_module_click error: ${err}`);
    }
  }

  set_allow_consent() {
    try{
      if(this.gtmEvent) this.gtmEvent.setConsent('consent', 'update', { 
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
      })
      if(this.fbEvent) this.fbEvent.setConsent('grant')
    } catch(err) {
      Sentry.captureException(`set consent error: ${err}`);
    }
  }

  set_deny_consent() {
    try{
      if(this.gtmEvent) this.gtmEvent.setConsent('consent', 'update', { 
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
      })
      if(this.fbEvent) this.fbEvent.setConsent('revoke')
    } catch(err) {
      Sentry.captureException(`set consent error: ${err}`);
    }
  }
}
export const initTrackingEvent = () => {
  window.trackingEvent = new TrackingEvent(window.dataLayer, window.fbq)
}

export default TrackingEvent